<template>
  <div class="detail-box position-header" v-loading="loading">
    <navHeader :titleList="['日化品牌', '添加产品']" />
    <div class="detail-content common-padding">
      <el-card class="box-card">
        <el-row type="flex" justify="center">
          <el-col :span="10">
            <el-form
              ref="form"
              class="add-form"
              :rules="rules"
              :model="form"
              label-width="140px"
            >
              <el-form-item label="关联品牌：" prop="brandId">
                <el-select filterable  v-model="form.brandId" placeholder="请选择" style="width: 100%">
                  <el-option
                    v-for="item in brands"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="一级品类：" prop="oneList">
                <el-checkbox-group
                    v-model="form.oneList"
                    @change="oneChange"
                    :max="3"
                >
                  <template v-for="(item, index) in selectCategoryList"  >
                    <el-checkbox disabled :label="item.id"  :key="index">{{item.name}}</el-checkbox>
                  </template>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="品类：" prop="category">
                  <div v-for="(item, index) in twoList" :key="index"><span style="color: blue">{{item.name}}：</span> <el-radio v-model="form.category" :key="inx" :label="i.id" v-for="(i, inx) in item.data">{{i.name}}</el-radio></div>
              </el-form-item>
              <el-form-item label="名称：" prop="name">
                <el-input v-model.trim="form.name"></el-input>
              </el-form-item>
              <el-form-item label="零售价：" prop="price">
                <el-input v-model.trim="form.price" type="number" placeholder="请填入数字"></el-input>
              </el-form-item>
              <el-form-item label="宣传图：" prop="picture">
                <uploadImage @success="getPicture" :img="pictureList" :limit="20" :size="2" />
              </el-form-item>
              <el-form-item label="视频：" prop="videoUrl">
                <videoUpload @success="getVideo" :list="videoList"  />
              </el-form-item>
              <el-form-item label="产品详情：" prop="detail">
                <editor ref="editor"   @setHtml="setHtml" />
              </el-form-item>
              <el-form-item label="寄样功能：" prop="sendSample">
                <el-radio-group v-model="form.sendSample">
                  <el-radio :label="item.id" v-for="item in sendSamples" :key="item.id">{{item.name}}</el-radio>
                </el-radio-group>
              </el-form-item>
<!--              <el-form-item label="是否备案：" prop="isRecord">-->
<!--                <el-radio-group v-model="form.isRecord" @change="changeRecord">-->
<!--                  <el-radio label="1">是</el-radio>-->
<!--                  <el-radio label="0">否</el-radio>-->
<!--                </el-radio-group>-->
<!--              </el-form-item>-->
              <el-form-item label="备案信息：" prop="record">
                <p style="color: #ee3d4a">请优先填写备案编号（含妆/特/消/械/药等），若未备案可填写其他执行标准编号。</p>
                <el-input v-model.trim="form.record" placeholder="请输入备案信息"></el-input>
              </el-form-item>
              <el-form-item label="是否是进口：" prop="wasForeign">
                <el-radio-group v-model="form.wasForeign" @change="form.address = ''">
                  <el-radio label="0">是</el-radio>
                  <el-radio label="1">否</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item v-if="form.wasForeign === '0'" label="生产地：" prop="address">
                <el-cascader
                    style="width: 100%"
                    v-model="form.address"
                    clearable
                    :options="originOptions"
                    :props="defaultProps"
                  ></el-cascader>
              </el-form-item>
              <el-form-item v-if="form.wasForeign === '1'" label="生产地：" prop="address">
                <el-select
                    filterable
                    style="width: 100%"
                      v-model="form.address"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in areaCodeList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
              </el-form-item>
              <el-form-item label="生产企业：" prop="factory">
                <el-input v-model.trim="form.factory"></el-input>
              </el-form-item>
              <el-form-item label="规格：" prop="size">
                <el-input v-model.trim="form.size" placeholder="如20ml/瓶"></el-input>
              </el-form-item>
              <el-form-item label="排序：" prop="sort">
                <el-input-number v-model="form.sort" :min="0" style="width: 100%"></el-input-number>
              </el-form-item>
            </el-form>
            <div class="info-footer">
              <el-button type="primary" @click="save">确定</el-button>
              <el-button @click="back">取消</el-button>
            </div>
          </el-col>
        </el-row>
      </el-card>
    </div>
  </div>
</template>
<script>
import navHeader from '../../components/navHeader.vue'
import uploadImage from '../../components/xcUpload.vue'
import editor from '../../components/editor.vue'
import videoUpload from '../../components/videoUpload'

export default {
  data () {
    return {
      id: '',
      loading: true,
      form: {
        detail: '',
        wasForeign: '1',
        isRecord: '1',
        oneList: [],
        address: [],
        category: '',
        picture: '',
        sendSample: ''
      },
      rules: {
        brandId: { required: true, message: '请选择关联品牌', trigger: 'blur' },
        name: {
          required: true,
          message: '请输入中文名',
          trigger: 'blur'
        },
        picture: {
          required: true,
          message: '请上传宣传图',
          trigger: 'blur'
        },
        one: {
          required: true,
          message: '请选择一级品类',
          trigger: 'blur'
        },
        category: {
          required: true,
          message: '请选择二级品类',
          trigger: 'blur'
        },
        origin: {
          required: true,
          message: '请选择原产地',
          trigger: 'blur'
        },
        isRecord: {
          required: true,
          message: '请选择是否备案',
          trigger: 'blur'
        },
        record: {
          required: true,
          message: '请输入备案信息',
          trigger: 'blur'
        },
        wasForeign: {
          required: true,
          message: '请选择是否是进口',
          trigger: 'blur'
        },
        address: {
          required: true,
          message: '请选择生产地',
          trigger: 'blur'
        }
        // sendSample: {
        //   required: true,
        //   message: '请选择寄样功能',
        //   trigger: 'blur'
        // }
      },
      sendSamples: [
        {
          name: '可以寄样',
          id: '1'
        },
        {
          name: '可以参观/看样',
          id: '2'
        },
        {
          name: '可供产品资料',
          id: '3'
        },
        {
          name: '以上都不支持',
          id: '4'
        }
      ],
      areaCodeList: [],
      originOptions: [],
      defaultProps: {
        children: 'children',
        label: 'name',
        value: 'id'
      },
      pictureList: [],
      videoList: [],
      brands: [],
      brandCategoryList: [],
      selectCategoryList: [],
      twoList: []
    }
  },
  components: {
    navHeader,
    uploadImage,
    editor,
    videoUpload
  },
  created () {
    if (this.$route.params.id) {
      this.id = this.$route.params.id
    } else {
      this.id = ''
    }
    this.getBrandCategoryList()
    this.getProducingAreaList()
    this.getAreaCode()
  },
  mounted () {
    this.$refs.editor.initEditor()
  },
  methods: {
    async getBrandList () {
      let { data: res } = await this.$http.get('/cosmeticProduct/cosmeticProduct/getBrandList')
      if (res.code === '200') {
        res.data.forEach(item => {
          if (item.id === this.id) {
            this.brands = [item]
            this.form.brandId = item.id
            this.form.oneList = item.one ? item.one.split(',') : []
            this.form.oneList.forEach(item => parseInt(item))
            this.brandCategoryList.forEach(item => {
              this.form.oneList.forEach(i => {
                if (i === item.id) {
                  this.selectCategoryList.push({
                    name: item.name,
                    id: item.id
                  })
                  this.twoList.push({
                    name: item.name,
                    id: item.id,
                    data: item.children
                  })
                }
              })
            })
          }
        })
      } else {
        this.$message.error(res.msg)
      }
      this.loading = false
    },
    getBrandCategoryList () {
      this.$http.get('/cosmeticBrand/cosmeticBrand/getBrandCategoryList').then(res => {
        if (res.data.code === '200') {
          this.brandCategoryList = res.data.data
          this.getBrandList()
        }
      })
    },
    oneChange () {
      this.twoList = []
      this.brandCategoryList.forEach(item => {
        this.form.oneList.forEach(i => {
          if (i === item.id) {
            this.twoList.push({
              name: item.name,
              id: item.id,
              data: item.children.map(n => n.name)
            })
          }
        })
      })
    },
    getProducingAreaList () {
      this.$http
        .get('/brandArea/getBrandAreaList')
        .then((res) => {
          if (res.data.code === '200') {
            this.originOptions = res.data.data
          }
        })
    },
    getAreaCode () {
      this.$http
        .get('/areaCode/getList')
        .then((res) => {
          console.log(res)
          if (res.data.code === '200') {
            res.data.data.forEach(item => {
              if (item.id !== '5000') {
                this.areaCodeList.push(item)
              }
            })
          }
        })
    },
    setHtml (html) {
      this.form.detail = html
    },
    getPicture (list) {
      this.form.picture = list.join(',')
    },
    getVideo (list) {
      this.form.videoUrl = list.map(item => item.url).join(',')
    },
    back () {
      this.$router.push('/rhBrand')
    },
    changeRecord (val) {
      this.form.record = ''
    },
    save () {
      this.$refs.form.validate(val => {
        if (val) {
          let params = JSON.parse(JSON.stringify(this.form))
          params.one = this.form.oneList.join(',')
          if (typeof (this.form.address) !== 'string') {
            params.address = this.form.address.join(',')
          }
          delete params.oneList
          this.$http.post('/cosmeticProduct/cosmeticProduct/add', params).then(res => {
            if (res.data.code === '200') {
              this.$message.success(res.data.msg)
              this.$router.push('/rhBrand')
            } else {
              this.$message.error(res.data.msg)
            }
          }).catch(e => {
            console.log(e)
          })
        } else {
          if (!this.form.category) return this.$message.error('请选择二级品类')
          if (!this.form.name) return this.$message.error('请输入中文名')
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/rhBrand/addProduct.vue